import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { switchMap } from 'rxjs';
import { CsrfService } from '../../services/csrf.service';

export const csrfInterceptor: HttpInterceptorFn = (request, next) => {
  const csrfService = inject(CsrfService);

  // Only add CSRF token to state-changing requests
  if (isStatefulRequest(request)) {
    return csrfService.getToken().pipe(
      switchMap(token => {
        const secureRequest = request.clone({
          setHeaders: {
            'X-CSRF-Token': token
          }
        });
        return next(secureRequest);
      })
    );
  }

  return next(request);
};

function isStatefulRequest(request: any): boolean {
  // Add CSRF token to POST, PUT, PATCH, DELETE requests
  return ['POST', 'PUT', 'PATCH', 'DELETE'].includes(request.method.toUpperCase());
}